import parse from "date-fns/parseISO";
import nameof from "../../../common/helpers/nameof";

import { shortDate } from "../../../common/helpers/date";
import { CsvColumn } from "../../../common/components/DownloadCsv";

import { MarketingActivity as Activity } from "../../../api";

const Columns: CsvColumn<Activity>[] = [{
  title: "Name",
  accessor: nameof<Activity>("name"),
}, {
  title: "Publication Live",
  accessor: x => !!x.publicationDate ? shortDate(parse(x.publicationDate)) : "",
}, {
  title: "Content Deadline",
  accessor: x => !!x.deadlineDate ? shortDate(parse(x.deadlineDate)) : "",
}, {
  title: "Completed",
  accessor: x => !!x.completedDate ? shortDate(parse(x.completedDate)) : "",
}, {
  title: "Status",
  accessor: nameof<Activity>("status"),
}];

export default Columns;
